import { EDITOR_VIEW_NAME } from "../core/constants";
import { translate } from "../core/i18n";
import { TemplateField } from "../core/types";
import { getViewData, setViewData } from "../core/views";
import { saveProjectInLocalProjectList } from "./localstorage/saver";

export function isTemplateProject() : boolean {
  const templateProject = getViewData(EDITOR_VIEW_NAME).project?.templateProject;
  if (templateProject !== undefined) {
    return true;
    //const exportUserRoles = getDomainCfg().viewSettings.features.exportUserRoles;
    //return exportUserRoles ? userHasRoleFromList(exportUserRoles) : true;
  }
  return false;
}

export function getTemplateFields() : TemplateField[] {
  const editorData = getViewData(EDITOR_VIEW_NAME);
  const templateProject = editorData.project?.templateProject;
  if (templateProject === undefined) { 
    return [];
  }

  let fields = [];
  Object.entries(templateProject).forEach(([key, value]) => { 
      const valueStr = `${value}`;
      if (valueStr.indexOf("$") < 0) return;
      const i18nKey = valueStr.replace("$","");
      fields.push({
        key : value,
        destination : key,
        text : translate(i18nKey),
        value : editorData.project[key]
      })
  })

  return fields;
}

export function setTemplateFields(newTemplateFields) {
  const editorData = { ...getViewData(EDITOR_VIEW_NAME) };
  let newProject = { ...editorData.project };
  newTemplateFields.forEach((newField) => {
    newProject[newField.destination] = newField.value
  })

  const newEditorData = { ...editorData,
    project : newProject
  };
  saveProjectInLocalProjectList(newEditorData);
  setViewData(EDITOR_VIEW_NAME, newEditorData);
}

export function getProjectFromTemplateDefinition() {
  const editorData = getViewData(EDITOR_VIEW_NAME);
  const templateProject = editorData.project?.templateProject;
  if (templateProject === undefined) { 
    return [];
  }

  let newProjectJson = { ...templateProject };
  Object.entries(templateProject).forEach(([key, value]) => { 
    const valueStr = `${value}`;
    if (valueStr.indexOf("$") < 0) return;
    newProjectJson[key] = editorData.project[key];
  });
  return JSON.stringify(newProjectJson);
}

export function setProjectFieldValueByKey(templateFields : TemplateField[], key : string, value : string) {
  const fieldIndex = templateFields.findIndex((item) => item.key === key);  
  let field = templateFields[fieldIndex];
  field.value = value;
  let newFieldState = [ ... templateFields ];
  newFieldState[fieldIndex] = field;

  return newFieldState;
}
